import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearningPathCardComponent } from './components/learning-path-card/learning-path-card.component';
import { SharedLibraryModule } from '../common/shared-library.module';
import { RouterModule } from '@angular/router';
import { MatProgressBarModule } from '@angular/material/progress-bar';



@NgModule({
  declarations: [
    LearningPathCardComponent
  ],
  exports: [
    LearningPathCardComponent
  ],
  imports: [
    CommonModule,
    SharedLibraryModule,
    RouterModule,
    MatProgressBarModule
  ]
})
export class LearningPathCardModule { }
